var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoaderBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166506 90.0649C-2.36809 63.6306 24.3762 40.2486 57.0361 23.6385C89.9182 6.91545 132.202 -5.35886 172.611 2.36353C210.86 9.67313 227.21 35.8448 242.677 59.1155C256.781 80.3354 274 105.255 253.701 124.367C234.581 142.37 192.096 134.315 158.406 138.462C127.229 142.299 97.4633 155.859 68.8754 147.115C33.0523 136.159 2.57233 115.156 0.166506 90.0649Z",
    fill: "#EFEAFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoaderBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loader-bg.754c6729fc635971c49201209b787288.svg";